import {UserApplication} from '@application/User';
import {viewUserHandlerFunction, ViewUserView} from '../../projection/viewUser';
import {PsFee} from '@application/PsFee';

const viewUserView: ViewUserView = async () => {
  try {
    const {payPsFee} = await PsFee.getInfo();
    const user = await UserApplication.getUserOverallInfo();
    if (user) user.migrated = !payPsFee;
    return user;
  } catch (error) {
    return null;
  }
};

export const viewUserHandler = viewUserHandlerFunction(viewUserView);
